let env = window.location.hostname.toLowerCase().split( '.' ).find( function ( chunk ) {
    return [ 'localhost', 'qa', 'pprd' ].indexOf( chunk ) >= 0;
} );

let isLocalhost = false;

if ( env === 'localhost' ) {
    env = 'qa';
    isLocalhost = true;

}

function getURL( url, isService ) {
    if ( isService && !isLocalhost ) {
        const hostParts = window.location.hostname.split( '.' );
        hostParts.shift();
        const completeUrl = `https://${ hostParts.join( '.' ) }/${ url }`;
        return completeUrl;
    } else if ( isService && isLocalhost ) {
        const completeUrl = `https://qa.recognition-now.io${ url }`;
        return completeUrl;
    }
    return url;
}

function getAlloyUrl( url ) {
    return url.toLowerCase().replace( '(env.)', env ? env + '.' : '' );
}

export const profileUrl = `https://${ window.location.hostname }/profile`;
export const incentivesUrl = `https://${ window.location.hostname }/incentives`;
export const towerUrl = `https://${ window.location.hostname }/home`;
export const helpCenterUrl = `https://${ window.location.hostname }/help-center`;
export const badgesUrl = `https://${ window.location.hostname }/badges-webapp`;
export const marketplaceUrl = `https://${ window.location.hostname }/marketplace`;
export const doorUrl = `https://${ window.location.hostname }/door`;
export const learningUrl = `https://${ window.location.hostname }/learning`;
export const celebrationMomentsUrl = `https://${ window.location.hostname }/celebration-moments`;
export const reportsUrl = `https://${ window.location.hostname }/reports`;
export const advisorUrl = `https://${ window.location.hostname }/elevate-advisor`;
export const tasksUrl = `https://${ window.location.hostname }/tasks-webapp`;
export const activityFeedUrl = `https://${ window.location.hostname }/activity-feed`;
export const deckUrl = `https://${ window.location.hostname }/component-deck`;
export const scormPlayerUrl = `https://${ window.location.hostname }/scorm-player`;
export const eventProxyUrl = getURL( '/api/v1/web-event-proxy', true );
export const idUrl = getURL( '/api/v1/id', true );
export const resourceCenterUrl = `https://${ window.location.hostname }/resource-center`;
export const alloyUrl = getAlloyUrl( 'https://alloy.(env.)biw.cloud/collect' );
export const nominationsUrl = `https://${ window.location.hostname }/nominations`;